import { APP_VERSION } from '~/src/constants'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('appVersion', APP_VERSION)
})